module.exports = __webpack_public_path__ + "static/media/1873.e367b720.jpg";